import classNames from "classnames";
import React, { Dispatch, useMemo } from "react";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";
import { useDispatch, useSelector } from "react-redux";
import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";

import styles from "./header.module.scss";
import TimezoneSelect from "./timezone-select/timezone-select.component";
import ChatInfoComponent from "./chat-info/chat-info.component";

import { makeSelectChatInfoById } from "~/app/selectors/chats";
import { ApplicationStore } from "~/app/application.store";
import chatActions from "~/app/chat/chat.actions";
import { setChatSelectFoldersModalIsOpen } from "~/app/modals/modals.actions";

const Header: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const chatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);
  const chatsCountAllNotifications: number = useSelector(
    (state: ApplicationStore) => state.chats.chatsCountAllNotifications
  );
  const folders: ChatFolderData[] = useSelector((state: ApplicationStore) => state.chatFolders.folders);

  const selectChatInfoById: (state: ApplicationStore, chatId: string | null) => ChatWithShortInfo | undefined = useMemo(
    () => makeSelectChatInfoById(),
    []
  );
  const selectChat: ChatWithShortInfo | undefined = useSelector((state: ApplicationStore) =>
    selectChatInfoById(state, chatId)
  );

  const handleLeaveChat: () => void = () => {
    dispatch(chatActions.switchSelectChat(null));
  };

  const handleSwitchChat: () => void = () => {
    if (chatId && selectChat) {
      dispatch(
        chatActions.switchCurrentChatArchive({
          chatId: chatId,
          isArchive: !selectChat.isArchived
        })
      );
    }
  };

  const handleChangeTimezone: (timezone: string) => void = (timezone: string) => {
    if (chatId && selectChat) {
      dispatch(chatActions.updateChat({ chatId: chatId, timezone }));
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftRow}>
        <div className={styles.backButtonWrapper} onClick={handleLeaveChat}>
          <div className={classNames(styles.backButton, styles.left)}></div>
          {chatsCountAllNotifications > 0 && (
            <div className={styles.countNotifications}>{chatsCountAllNotifications}</div>
          )}
        </div>
        <ChatInfoComponent />
      </div>
      <div className={styles.rightRow}>
        {chatId && selectChat && (
          <>
            <TimezoneSelect onChange={handleChangeTimezone} timezone={selectChat.timezone} />
            <div className={styles.settingsWrapper}>
              <button onClick={(): void => handleSwitchChat()}>
                {selectChat.isArchived ? "Unarchive" : "Archive"}
              </button>
            </div>
            {folders.length > 0 && selectChat.isArchived === false && (
              <div className={styles.settingsWrapper}>
                <button onClick={(): void => dispatch(setChatSelectFoldersModalIsOpen(true))}>Select Folders</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
